import React from "react";
// import Navbar from "./Navbar";
import "../style/subscription.css";
import Logo from "../Assets/Images/GW-logo.webp";
import playwinrepeat from "../Assets/Images/play-win-repeat.webp";
import smartWatchImg from "../Assets/Images/smartwatch.webp";

const Landing = (props) => {
  function keyFunction(event) {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const validChars = /^[0-9]+$/;

    if (!validChars.test(keyValue)) {
      event.preventDefault();
    }
  }
  return (
    <>
      {props.isModel ? (
        <div className="lp-content">
          <div className="c-div">
            <img
              className="logo"
              fetchpriority="high"
              width="137"
              height="73"
              src={Logo}
              alt="logo"
            />
            <div className="title">
              {" "}
              Enter the<span> World of Gaming</span> Excitement with{" "}
              <span>Jazz Game World.</span>  Level Up Your <span>Entertainment!</span>
            </div>
            <button onClick={() => props.onHandleJoinNow()}>Join Now</button>
          </div>
        </div>
      ) : (
        <div className="px-0 subs-screen">
          <div className="animated-bg">
            <div className="lines">
              <span style={{ "--i": 11 }}></span>
              <span style={{ "--i": 12 }}></span>
              <span style={{ "--i": 22 }}></span>
              <span style={{ "--i": 28 }}></span>
              <span style={{ "--i": 23 }}></span>
              <span style={{ "--i": 11 }}></span>
              <span style={{ "--i": 12 }}></span>
              <span style={{ "--i": 22 }}></span>
              <span style={{ "--i": 28 }}></span>
              <span style={{ "--i": 23 }}></span>
              <span style={{ "--i": 18 }}></span>
              <span style={{ "--i": 12 }}></span>
              <span style={{ "--i": 16 }}></span>
              <span style={{ "--i": 20 }}></span>
              <span style={{ "--i": 25 }}></span>
              <span style={{ "--i": 18 }}></span>
              <span style={{ "--i": 21 }}></span>
              <span style={{ "--i": 26 }}></span>
              <span style={{ "--i": 17 }}></span>
              <span style={{ "--i": 13 }}></span>
              <span style={{ "--i": 20 }}></span>
              <span style={{ "--i": 28 }}></span>
              <span style={{ "--i": 23 }}></span>
              <span style={{ "--i": 18 }}></span>
              <span style={{ "--i": 12 }}></span>
            </div>

            <div className="otpouterDiv outerDivMobile">
              <div className="custom-container">
                <div className="logo paralogo">
                  <img src={Logo} width={110} height={92} alt="logo" />
                </div>
                <div className="newParamWraper">
                  <div className="custom-row">
                    {/* <Navbar /> */}
                    {/* ------------------------------- Enter Ph number -------------------------------  */}
                    <div className="custom-col">
                      <div className="pwgImg">
                        {props.parameter === "smartwatch" ? (
                          <img
                            src={smartWatchImg}
                            width={377}
                            height={358}
                            alt="main-image"
                          />
                        ) : (
                          <img
                            src={playwinrepeat}
                            width={377}
                            height={358}
                            alt="main-image"
                          />
                        )}
                        {/* <img src={playwinrepeat} width={377} height={358} /> */}
                      </div>
                    </div>

                    <div className="custom-col">
                      <div className="subOuterbox">
                        <div className="subscribeBox">
                          <div
                            className="round-gradient"
                            style={{ height: "96.5%" }}
                          ></div>
                          <div className="subinnerBox newparam">
                            <div className="subscriptionText">
                              {/* <h3>
                                  Subscribe &amp; Win <br />
                                  Rs 10,000
                                </h3> */}
                              <p className="getotp">
                                Please input number to get OTP
                              </p>
                            </div>

                            <div
                              action=""
                              onSubmit={
                                props.phNumber
                                  ? props.SignUp
                                  : (e) => e.preventDefault()
                              }
                            >
                              <div>
                                <div className="otpinput-group">
                                  <div className="input-group-prepend">
                                    <span className="input-group-text">
                                      +92
                                    </span>
                                  </div>
                                  <input
                                    type="tel"
                                    autoComplete="off"
                                    className="cform-control rounded tel-field"
                                    style={{ color: "white" }}
                                    placeholder="XXX - XXX - XXXX"
                                    value={props.phoneNo}
                                    onChange={props.onTextChange}
                                    maxLength="10"
                                    onKeyPress={keyFunction}
                                    pattern="3[0-9]{9}"
                                  />
                                </div>
                                {props.errorMsg && (
                                  <p className="subs-error">{props.errorMsg}</p>
                                )}
                              </div>

                              <div className="input-group-append">
                                {props.isloader === false ? (
                                  <button
                                    className="otpBtn"
                                    type="submit"
                                    id="button-addon2"
                                    onClick={() => props.onNextPressed()}
                                  >
                                    Get Otp
                                  </button>
                                ) : (
                                  <button
                                    className="otpBtn"
                                    type="submit"
                                    id="button-addon2"
                                  >
                                    <div className="spinner-container-small">
                                      <div className="loading-spinner-small"></div>
                                    </div>
                                  </button>
                                )}
                              </div>
                            </div>

                            <p className="taxpermonth">
                              Service Charges: Rs. 8.37+T/Day.
                              {/* * Only for Rs. 3.5 + Tax/Day (Prepaid) / & Rs. 35.85 +{" "}
                          <br /> Tax/Month (Postpaid) * */}
                            </p>

                            <div className="links">
                              <a href="/privacypolicy" target="_blank">
                                Privacy Policy
                              </a>
                              <span></span>
                              <a href="/terms" target="_blank">
                                Terms &amp; Conditions
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Landing;
